import React, { useContext } from 'react';
import { useTranslation } from '../hooks/useTranslation';
import { usePageClassName } from '../hooksInternal/usePageClassName';
import { Context as ConfigContext } from '../Config';
import WithTitle from '../componentsInternal/WithTitle';
import { Helmet } from '../components/meta';
const ErrorPage = () => {
    const { t } = useTranslation();
    usePageClassName('error-page');
    const { pages } = useContext(ConfigContext);
    const title = t('pageTitles.error');
    const Page = pages.error.component;
    return (React.createElement(WithTitle, { title: title },
        React.createElement(Helmet, null,
            React.createElement("meta", { name: "robots", content: "noindex" })),
        React.createElement(Page, null)));
};
export default ErrorPage;
//# sourceMappingURL=error.js.map